export const styles = (theme: any) => {
    return {
        root: {
            color: 'white',
            height: '30px',
            margin: '0px 0px 1px 1%',
            width: '98%',
            paddingLeft:'5px'
        },
        iconContainer: {
            minWidth: '30px',
        },
        icon: {
            color: 'white',
            height: '15px'
        },
        text: {
            display: 'flex',
            padding: '0px'
        }
    }
}